/* PARMUN — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll + cifras animadas ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.aq-reveal:not(.aq-visible), [data-aq-count]:not([data-aq-done])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('aq-visible'); if (el.dataset.aqCount) finishCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('aq-visible');
        if (el.dataset.aqCount) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function finishCount(el) { el.textContent = el.dataset.aqCount + (el.dataset.aqSuffix || ''); el.dataset.aqDone = '1'; }
  function countUp(el) {
    var target = parseFloat(el.dataset.aqCount) || 0;
    var suffix = el.dataset.aqSuffix || '';
    var dur = 1400, start = null;
    el.dataset.aqDone = '1';
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var frames = document.querySelectorAll('[data-aq-parallax]');
    if (!frames.length || reduceMotion) return;
    var ticking = false;
    function update() {
      frames.forEach(function (f) {
        var k = parseFloat(f.dataset.aqParallax) || 0;
        var r = f.getBoundingClientRect();
        var offset = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        f.style.setProperty('--aq-parallax', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Comparador antes / después ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('.aq-slider').forEach(function (s) {
      var input = s.querySelector('input[type=range]');
      if (!input || s.dataset.aqReady) return;
      s.dataset.aqReady = '1';
      function set() { s.style.setProperty('--aq-pos', input.value + '%'); }
      input.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-aq-product]').forEach(function (wrap) {
      if (wrap.dataset.aqReady) return;
      wrap.dataset.aqReady = '1';
      var dataEl = wrap.querySelector('[data-aq-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = wrap.querySelector('input[name="id"]');
      var priceEl = wrap.querySelector('[data-aq-price]');
      var compareEl = wrap.querySelector('[data-aq-compare]');
      var saveEl = wrap.querySelector('[data-aq-save]');
      var btn = wrap.querySelector('[data-aq-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var msg = wrap.querySelector('[data-aq-msg]');
      var mainImg = wrap.querySelector('[data-aq-main]');
      var thumbs = wrap.querySelectorAll('.aq-thumb');
      var money = wrap.dataset.aqMoney || '${{amount}}';
      var txtAdd = wrap.dataset.aqAddTxt || 'Add to cart';
      var txtSold = wrap.dataset.aqSold || 'Sold out';

      function fmt(cents) {
        var n = (cents / 100).toFixed(2);
        var withComma = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
                    .replace(/\{\{\s*amount\s*\}\}/, withComma);
      }

      /* Galería */
      function showImage(src, srcset) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
          mainImg.style.opacity = '1';
        }, 160);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          showImage(t.dataset.src, t.dataset.srcset);
        });
      });

      /* Barra fija de compra: aparece cuando el botón principal sale de pantalla */
      var sticky = wrap.querySelector('[data-aq-sticky]');
      var stickyPrice = wrap.querySelector('[data-aq-sticky-price]');
      if (sticky && btn) {
        var stickyOn = null;
        var checkSticky = function () {
          var r = btn.getBoundingClientRect();
          var show = r.bottom < 0 || r.top > window.innerHeight;
          if (show === stickyOn) return;
          stickyOn = show;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        window.addEventListener('scroll', checkSticky, { passive: true });
        window.addEventListener('resize', checkSticky);
        checkSticky();
        var sBtn = sticky.querySelector('[data-aq-sticky-btn]');
        if (sBtn) sBtn.addEventListener('click', function () {
          var f = btn.form;
          if (f && f.requestSubmit) f.requestSubmit(btn); else btn.click();
        });
      }

      /* Variantes: grupos de pastillas. Un grupo puede ser una opción
         completa o una parte de una opción ("Color - Kit"). */
      var groups = wrap.querySelectorAll('[data-aq-group]');
      var hasGroups = groups.length > 0 && variants.length > 0;

      function currentSelection() {
        var byOption = {};
        groups.forEach(function (g) {
          var opt = g.dataset.aqOption;
          var part = parseInt(g.dataset.aqPart || '-1', 10);
          var active = g.querySelector('.aq-pill.is-active');
          var val = active ? active.dataset.value : '';
          if (part < 0) byOption[opt] = val;
          else { byOption[opt] = byOption[opt] || []; byOption[opt][part] = val; }
        });
        Object.keys(byOption).forEach(function (k) {
          if (Array.isArray(byOption[k])) byOption[k] = byOption[k].join(wrap.dataset.aqSep || ' - ');
        });
        return byOption;
      }
      function findVariant(sel) {
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return sel[i] === undefined || sel[i] === val; });
        });
      }
      function update() {
        var sel = currentSelection();
        groups.forEach(function (g) {
          var label = g.parentNode.querySelector('[data-aq-chosen]');
          var active = g.querySelector('.aq-pill.is-active');
          if (label && active) label.textContent = active.dataset.label || active.dataset.value;
        });
        var v = findVariant(sel);
        if (!v) {
          if (btn) btn.disabled = true;
          if (btnLabel) btnLabel.textContent = wrap.dataset.aqUnavailable || 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (stickyPrice) stickyPrice.textContent = fmt(v.price);
        var sb = wrap.querySelector('[data-aq-sticky-btn]');
        if (sb) sb.disabled = !v.available;
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = fmt(v.compare_at_price); compareEl.hidden = false;
            if (saveEl) { saveEl.hidden = false; saveEl.textContent = (wrap.dataset.aqSaveTxt || 'Save') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
        }
        if (btn) btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? txtAdd : txtSold;
        if (v.featured_image && v.featured_image.src) {
          var src = v.featured_image.src;
          src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          showImage(src, null);
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId == (v.featured_media && v.featured_media.id)); });
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var pill = e.target.closest('.aq-pill');
          if (!pill) return;
          g.querySelectorAll('.aq-pill').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
          pill.classList.add('is-active'); pill.setAttribute('aria-pressed', 'true');
          update();
        });
      });

      /* Cantidad */
      var qty = wrap.querySelector('[data-aq-qty]');
      wrap.querySelectorAll('[data-aq-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.aqStep, 10));
          qty.value = n;
        });
      });

      /* Añadir al carrito con el cajón de carrito de Dawn */
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          var hasDrawer = drawer && typeof drawer.renderContents === 'function';
          var addon = form.querySelector('[data-aq-addon]');
          var withAddon = addon && addon.checked;
          if ((!hasDrawer && !withAddon) || !window.fetch) return; // envío normal
          e.preventDefault();
          if (msg) msg.textContent = '';
          btn.disabled = true;
          var fd = new FormData(form);
          if (withAddon) {
            /* Ducha + complemento en un solo pedido al carrito */
            var main = new FormData();
            main.append('items[0][id]', fd.get('id'));
            main.append('items[0][quantity]', fd.get('quantity') || 1);
            main.append('items[1][id]', addon.value);
            main.append('items[1][quantity]', 1);
            fd = main;
          }
          if (!hasDrawer) {
            fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', body: fd })
              .then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
              .catch(function () { btn.disabled = false; form.submit(); });
            return;
          }
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            btn.disabled = false;
            if (res.status) { if (msg) msg.textContent = res.description || res.message || 'Error'; return; }
            drawer.classList.remove('is-empty');
            var empty = drawer.querySelector('.drawer__inner-empty'); if (empty) empty.remove();
            drawer.renderContents(res);
          }).catch(function () { btn.disabled = false; form.submit(); });
        });
      }
      if (hasGroups) update();
    });
  }

  function initAll(root) { initReveals(root); initSliders(root); initProduct(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); initParallax(); });
  /* Editor de Shopify: re-inicializa al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
